import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { CompanyProfileIncompleteModalService } from '@services/company-profile-incomplete-modal.service';
import { CompaniesService } from '@services/companies.service';
import { CompanyModel } from '@data-layer/models/companies';

@Component({
  selector: 'company-profile-incomplete-modal',
  templateUrl: './company-profile-incomplete-modal.component.html',
  styleUrls: ['./company-profile-incomplete-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyProfileIncompleteModalComponent {
  public isOpen$: Observable<boolean>;

  constructor(
    private companyProfileIncompleteModalService: CompanyProfileIncompleteModalService,
    private companiesService: CompaniesService,
    private router: Router,
  ) {
    this.isOpen$ = this.companyProfileIncompleteModalService.isOpen$;
  }

  // support / admin act on another company's filing — their "current company" is not the one to fix
  public get isShowGoToProfile(): boolean {
    return !this.companiesService.isSupportOrAdmin() && this.companyId > 0;
  }

  public onOpenChange(isOpen: boolean): void {
    if (!isOpen) {
      this.companyProfileIncompleteModalService.close();
    }
  }

  public onGoToProfile(): void {
    this.companyProfileIncompleteModalService.close();

    this.router.navigate(['/companies', 'account-settings', 'company-view', this.companyId], {
      queryParams: { isEditViewOpen: true },
    });
  }

  private get companyId(): number {
    const company: CompanyModel = this.companiesService.getCompany();

    return !!company ? company.id : null;
  }
}
